import React from 'react'

function FormFullPageLayout({ children }: { children: React.ReactNode }) {
  return <div className="tw:w-full tw:bg-gray-100">{children}</div>
}

export default FormFullPageLayout
